// --- Types & core contracts ---
export type {
  User,
  PasswordCredentials,
  RedirectCredentials,
  Credentials,
  Tokens,
  TokenStorage,
  AuthEndpoints,
  AuthEventMap,
  AuthEventName,
  AuthEventListener,
  EventEmitter,
  AuthProvider as AuthProviderContract,
  RequestConfig,
} from "./types";
export { AuthHttpError } from "./types";

// --- API layer ---
export { HttpClient, type HttpClientOptions } from "./api/HttpClient";
export { SessionManager, type SessionManagerOptions } from "./api/SessionManager";
export { AuthClient, type AuthClientOptions } from "./api/AuthClient";
export { LocalStorageTokenStorage, SessionStorageTokenStorage, MemoryTokenStorage } from "./api/TokenStorage";

// --- Providers ---
export { BaseAuthProvider, type BaseAuthProviderConfig } from "./providers/BaseAuthProvider";
export { JwtProvider, type JwtProviderConfig } from "./providers/JwtProvider";
export { OAuthProvider, type OAuthProviderConfig, type OAuthEndpoints } from "./providers/OAuthProvider";
export { KeycloakProvider, type KeycloakProviderConfig } from "./providers/KeycloakProvider";
export { Auth0Provider, type Auth0ProviderConfig } from "./providers/Auth0Provider";
export { AzureProvider, type AzureProviderConfig } from "./providers/AzureProvider";

// --- Context & hooks ---
export { AuthContext, type AuthContextValue } from "./context/AuthContext";
export { AuthProvider, type AuthProviderProps } from "./context/AuthProvider";
export { useAuth } from "./hooks/useAuth";
export { useSession, type SessionSnapshot } from "./hooks/useSession";

// --- UI components ---
export { LoginPage, type LoginPageProps } from "./components/LoginPage";
export { LoginForm, type LoginFormProps } from "./components/LoginForm";
export { LogoutButton, type LogoutButtonProps } from "./components/LogoutButton";
export { UserMenu, type UserMenuProps } from "./components/UserMenu";
export { LoadingScreen, type LoadingScreenProps } from "./components/LoadingScreen";
export { AuthGuard, type AuthGuardProps } from "./components/AuthGuard";
export { SessionExpiredDialog, type SessionExpiredDialogProps } from "./components/SessionExpiredDialog";

// --- Utilities ---
export { SimpleEventEmitter } from "./utils/EventEmitter";
export { BroadcastBus, type BroadcastMessage } from "./utils/BroadcastBus";

// Note: `./router/AuthRoutes` (ProtectedRoute / PublicOnlyRoute) is intentionally
// NOT re-exported here — it depends on the optional `react-router-dom` peer
// dependency. Import it directly: `import { ProtectedRoute } from "@ferrumec/auth/router"`.
